/**
 * NOT awaited by the bootstrap orchestrator: the page mounts in idle/loading
 * right away and the search resolves async via `useFindStore.searchPhase`.
 * Awaiting would block render on the empty-URL case.
 */

import { useFindStore } from '../useFindStore'

const readTermsFromUrl = () => {
    if (typeof window === 'undefined' || !window.location) return []
    const params = new URLSearchParams(window.location.search)
    return params
        .getAll('q')
        .map(t => t.trim())
        .filter(Boolean)
}

export const bootstrapSearchView = () => {
    const initialTerms = readTermsFromUrl()
    if (initialTerms.length === 0) {
        console.log('[Bootstrap] Step 4: Search view — idle (no ?q in URL)')
        return
    }
    console.log(
        `[Bootstrap] Step 4: Search view — seeding ${
            initialTerms.length
        } term(s) from URL: [${initialTerms.join(', ')}]`
    )
    useFindStore.getState().setTerms(initialTerms)
}
